define('common/views/download_view',['require','exports','module','base/view','common/models/appstate','env','services/auth/info','ldsh!../templates/download_leads_notification'],function(require, exports, module) {
  "use strict";

  var View = require("base/view"),
      AppState = require("common/models/appstate"),
      config = require("env"),
      AuthInfo = require("services/auth/info");

  module.exports = View.extend({
    template: require("ldsh!../templates/download_leads_notification"),
    className: "ongoing-task-notice",

    events: {
      "click .js-action": "doAction",
      "click .js-cancel": "cancelDownload"
    },

    helpers: function() {
      return {
        getState: _.bind(this.model.getState, this.model)
      };
    },

    constructor: function(options) {
      options = options || {};
      // Automatically binded to AppState model for CSV File
      module.exports.__super__.constructor.call(this, _.extend(options, {model: AppState._csvFile}));
    },

    onRender: function() {
      var state = this.model.getState();
      this.$el.toggleClass("hidden", state === "idle");
      this.$el.toggleClass("success", state === "ready");
      this.$el.toggleClass("error", state === "error");
      this.$el.i18n();
    },

    doAction: function(e) {
      e.preventDefault();
      if (this.model.has("url")) this.download();
      else this.retry();
    },

    download: function(){
      var authInfo = new AuthInfo();
      authInfo.initFromLocalStorage();
      window.open(config.apiHost + this.model.get("url") + "?bearer=" + authInfo.getAccessToken());
      this.$el.toggleClass("hidden", true);
    },

    retry: function() {
      this.model.restartDownload();
    },

    cancelDownload: function(e) {
      e.preventDefault();
      this.model.cancelDownload();
    }
  });

});

